import { render } from "./TheHeader.vue?vue&type=template&id=4d36b196&scoped=true&ts=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=4d36b196&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d36b196"],['__file',"resources/js/components/app/header/TheHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d36b196"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d36b196', __exports__)) {
    console.log('reload')
    api.reload('4d36b196', __exports__)
  }
  
  module.hot.accept("./TheHeader.vue?vue&type=template&id=4d36b196&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('4d36b196', render)
  })

}


export default __exports__